






































// @ is an alias to /src
import { Component, Vue } from "vue-property-decorator";
import Navbar from "@/components/Navbar.vue";
import Footer from "@/components/Footer.vue";

@Component({
  components: {
    Navbar,
    Footer,
  },
})
export default class Terminos extends Vue {}
